import { Component, OnInit } from '@angular/core';
import { Stat, Stats } from 'src/app/model/stats/stats';
import { StatsService } from 'src/app/services/http/stats/stats.service';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
registerLocaleData(localeFr, 'fr');

const NB_JOURS: number = 14;

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})


export class StatisticsComponent implements OnInit {

  /**Permet d'affecter une couleur à la case en fonction de la valeur de ces variables */
  private TTC_VALUES: any[] = [{ answer: { 'verygood': true }, value: 100000 }, { answer: { 'good': true }, value: 70000 }, { answer: { 'warning': true }, value: 40000 }, { answer: { 'verywarning': true }, value: 30000 }, { answer: { 'alert': true }, value: 20000 }, { answer: { 'bad': true }, value: 15000 }];
  private MOY_PIZZAS_VENDUES: any[] = [{ answer: { 'verygood': true }, value: 49.5 }, { answer: { 'good': true }, value: 22 }, { answer: { 'warning': true }, value: 17 }, { answer: { 'verywarning': true }, value: 12.5 }, { answer: { 'alert': true }, value: 10.5 }, { answer: { 'bad': true }, value: 5.5 }];
  private MOY_CA_TTC: any[] = [{ answer: { 'verygood': true }, value: 200 }, { answer: { 'good': true }, value: 115 }, { answer: { 'warning': true }, value: 95 }, { answer: { 'verywarning': true }, value: 75 }, { answer: { 'alert': true }, value: 50 }, { answer: { 'bad': true }, value: 20 }];
  private MOY_CA_TTC_28: any[] = [{ answer: { 'verygood': true }, value: 50 }, { answer: { 'good': true }, value: 25 }, { answer: { 'warning': true }, value: 20 }, { answer: { 'verywarning': true }, value: 14.5 }, { answer: { 'alert': true }, value: 12.5 }, { answer: { 'bad': true }, value: 9.5 }];

  constructor(private service: StatsService, private builder: FormBuilder) { }

  //public color: ThemePalette = 'primary';
  //public mode: ProgressSpinnerMode = 'determinate';
  public stats !: Stats | any;
  public currentDay = new Date();
  public listeDates: any[] = [];
  public sortDirection: boolean = false;
  public departements:any = [];
  form !: FormGroup;
  public filteredStat !: Stat[] | any;


  ngOnInit(): void {

    this.form = this.builder.group({
      dept: [''],
    })
    
    this.service.getStatsData().subscribe((stats) => {
      this.stats = stats;
      this.filteredStat = stats.stats2;
      var depts  = new Set(stats.stats2.map(item =>
      item.departement
      ));
      this.departements = Array.from(depts.values()).sort();
    });
    


    /**Get the last days for the html  */
    for (let i = 0; i < NB_JOURS; i++) {
      var jour = new Date(this.currentDay)
      jour.setDate(this.currentDay.getDate() - i);
      jour.toLocaleString();
      // console.log(listeJour)
      this.listeDates.push(jour.getDate() + '/' + (jour.getMonth() + 1));
    }
  }

  // Obtenir la gamme de couleur en fonction des valeurs pour chacun des champs : 

  public getCaTTCColor(chaine: any): any {
    for (let i = 0; i < this.TTC_VALUES.length; i++) {
      let element = this.TTC_VALUES[i];
      if (parseInt(chaine) > element.value) {
        return element.answer;
      }
    }
    return { verybad: true };
  }

  public getMoyennePizzasVenduesColor(chaine: string): any {
    for (let i = 0; i < this.MOY_PIZZAS_VENDUES.length; i++) {
      let element = this.MOY_PIZZAS_VENDUES[i];
      if (parseInt(chaine) > element.value) {
        return element.answer;
      }
    }
    return { verybad: true };
  }

  public getMoyenneCATTCColor(chaine: string): any {
    for (let i = 0; i < this.MOY_CA_TTC.length; i++) {
      let element = this.MOY_CA_TTC[i];
      if (parseInt(chaine) > element.value) {
        return element.answer;
      }
    }
    return { verybad: true };
  }

  public getMoyenneCATTC28Color(chaine: string): any {
    for (let i = 0; i < this.MOY_CA_TTC_28.length; i++) {
      let element = this.MOY_CA_TTC_28[i];
      if (parseInt(chaine) > element.value) {
        return element.answer;
      }
    }
    return { verybad: true };
  }


  public getRegPanneColor(chaine: string) {
    if (parseFloat(chaine) > 1) return 'verybad';
    else if (parseFloat(chaine) > 0.8 && parseInt(chaine) <= 1) return 'bad';
    else if (parseFloat(chaine) > 0.6 && parseInt(chaine) <= 0.8) return 'alert';
    else if (parseFloat(chaine) > 0.4 && parseInt(chaine) <= 0.3) return 'warning';
    else if (parseFloat(chaine) > 0.2 && parseInt(chaine) < 0.1) return 'good';
    else return 'verygood';
  }

  /**
   * Trier les données de manière décroissante/croissante lorsque l'on clique sur un th. 
   */
  public sortColumn(column: string): void {
    let dataType ;

    for(let i = 0; i < this.filteredStat.length ; i ++) {
      dataType = typeof this.filteredStat[i][column];
      console.log(dataType);
      if(dataType !== undefined) {
        break;
      }
    }
    
    this.sortDirection = !this.sortDirection;
    switch (dataType) {
      case 'number':
        this.sortNumberColumn(this.sortDirection, column);
        break;

      case 'string':
        this.sortStringColumn(this.sortDirection, column);
        break;
    }

  }

/**
 * Tri avec valeurs de type 'number'
 * @param sort 
   * @param columnName 
 */
  public sortNumberColumn(sort: any, columnName: any): void {
    this.filteredStat = this.filteredStat.sort((a: any, b: any) => {
      return sort ? a[columnName] - b[columnName] : b[columnName] - a[columnName];
    });
  }

/**
 * Tri avec des valeurs de type 'string'
   * @param sort 
   * @param columnName 
 */
  public sortStringColumn(sort: any, columnName: any): void {
    this.filteredStat = this.filteredStat.sort((a: any, b: any) => {
      if (a[columnName] !== undefined && a[columnName] !== null && a[columnName] !==0 && b[columnName] !== undefined && b[columnName] !== null && b[columnName] !==0) {
        return sort ? a[columnName].localeCompare(b[columnName], undefined, { numeric: true }) : b[columnName].localeCompare(a[columnName], undefined, { numeric: true });
      } else if(a[columnName] === undefined || a[columnName] === null || a[columnName] === 0) {
        a[columnName] = "";
        return sort ? a[columnName].localeCompare(b[columnName], undefined, { numeric: true }) : b[columnName].localeCompare(a[columnName], undefined, { numeric: true });
      }else{
        b[columnName] = "";
        return sort ? a[columnName].localeCompare(b[columnName], undefined, { numeric: true }) : b[columnName].localeCompare(a[columnName], undefined, { numeric: true });
      }
    });
  }


  /**
   * Trier les valeurs du tableau concernant les ventes des 13 derniers jours. 
   * @param vente 
   * @param index 
   */
  public sortJoursValues(vente: string, index: any) {

    let dataType;
    dataType = typeof this.filteredStat[0][vente][index];

    console.log(dataType);
    this.sortDirection = !this.sortDirection;
    switch (dataType) {
      case 'number':
        this.sortJourColumn(this.sortDirection, vente, index);
        break;
    }

  }

  /**
   * Tri avec des valeurs de type number
     * @param sort 
   * @param columnName 
   * @param index 
   */
  public sortJourColumn(sort: any, columnName: any, index: any): void {
    this.filteredStat = this.filteredStat.sort((a: any, b: any) => {

      return sort ? a[columnName][index] - b[columnName][index] : b[columnName][index] - a[columnName][index];

    });
  }

  /**
   * Replace floats by integers for display
   * @param machineCa 
   * @returns 
   */
  public displayIntegerValue(value: string): number {
    return parseInt(value);
  }

  /**
   * Separate thousands with a space
   * @param value 
   * @returns 
   */
  public separateThousands(value: number): any {
    if(value != null){
      return value.toLocaleString();
    } else {
      return value;
    }
    
  }

  //Filter for departement

  public onFilterDept(){
    this.filteredStat = this.stats.stats2.filter((item: Stat) => {
      return this.form.value.dept.includes(item.departement);      
    });
    console.log(this.filteredStat);
  }

  public deselectAll(){
    this.form.controls['dept'].setValue([]);
    this.filteredStat = this.stats.stats2;
    console.log(this.filteredStat);
  }

}
